import React, { useState, useEffect } from "react";
import { CiEdit } from "react-icons/ci";
import { MdDelete, MdOutlineKeyboardArrowDown } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BiSolidCheckSquare, BiSolidXSquare } from "react-icons/bi";
import { FaCalendar } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { HiOutlineEye } from "react-icons/hi";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";
import useEncryption from "../useEncryption/useEncryption";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { usePagination } from "../Pagination/usePagination";
import { io } from "socket.io-client";
const TodoListUser = ({ searchUser }) => {
  const { decryptData } = useEncryption();
  const navigate = useNavigate();

  const [allTodoUserData, setAllTodoUserData] = useState([]); // use User Todo Table time this state
  const [showAllUser, setShowAllUser] = useState([]);
  const [socket, setSocket] = useState(null);
  const [openEdit, setOpenEdit] = useState(false); // Edit Form Open
  const [getEditId, setEditID] = useState(); // Edit click ID get and set
  const [editData, setEditData] = useState({}); // Edit API Data set
  const [selectuser, setSelectuser] = useState("");
  const [selectadmin, setSelectadmin] = useState("");
  const [getId, setId] = useState(""); // use Delete API
  const [showModal, setShowModal] = useState(false); // Delete Popup
  const [isListVisible, setIsListVisible] = useState(false);
  const [searchText, setSearchText] = useState();
  const [filtered, setFilteredData] = useState([]);
  const [selectuserid, setSelectuserid] = useState("");
  const [filterdata, setFilterdata] = useState([]);
  const [createtask, setCreatetask] = useState(false);

  const { sliceData, currentPage, numbers, totalPages, goToPage } =
    usePagination(filterdata, 10);

  useEffect(() => {
    const results = allTodoUserData.filter((item) => {
      const searchTerm = searchUser.toLowerCase();
      const itemNameMatch =
        item?.name?.toLowerCase().includes(searchTerm) ||
        item?.assignto?.toLowerCase().includes(searchTerm) ||
        item?.role?.toLowerCase().includes(searchTerm) ||
        item?.assigndate?.toLowerCase().includes(searchTerm) ||
        item?.deadline?.toLowerCase().includes(searchTerm);
      return itemNameMatch;
    });
    setFilterdata(results);
    goToPage(1);
  }, [searchUser]);

  const opencreatetask = () => {
    setCreatetask(!createtask);
  };

  //socket through notification
  const emitEditMessage = (id) => {
    console.log("edit==========================================> ", id);
    socket.emit("edit_todo", { id: id });

    console.log("Hello EditTodo Done");
  };
  const emitEdittodoMessage = (id) => {
    // socket.emit('join', {
    //   userid: id,
    // })
    const abc = {
      targetUserId: id,
      message: "you have a new notification",
    };
    socket.emit("edit_todo_message", abc);
    console.log("new message send");
  };
  // Get All Todolist Show
  const getTodolistUserData = async () => {
    await axiosInstanceAuth
      .get("/viewall_task")
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setAllTodoUserData(myData?.data || []);
        setFilterdata(myData?.data || []);
        console.log("TodoUserTableData---->", myData);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    getTodolistUserData();
  }, []);

  // Add user code
  const [todoUserFields, setTodoUserFields] = useState({
    name: "",
    description: "",
    assignto: "",
    role: "",
    assigndate: "",
    deadline: "",
  });

  const onChangeInput = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    setTodoUserFields({
      ...todoUserFields,
      [name]: value,
    });
  };

  const mydata = {
    name: todoUserFields?.name,
    description: todoUserFields?.description,
    assignto: selectadmin,
    role: todoUserFields?.role,
    assigndate: todoUserFields?.assigndate,
    deadline: todoUserFields?.deadline,
  };

  // Add Todo User task API code
  const handleSubmit = async () => {
    await axiosInstanceAuth
      .post("/create_task", mydata)
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        console.log("User TODO Data ===---===>>>", myData);
        console.log("=========myData", myData);
        if (myData?.status) {
          setTodoUserFields({
            name: "",
            description: "",
            assignto: "",
            role: "",
            assigndate: "",
            deadline: "",
          });
          emitEdittodoMessage(selectadmin);
          emitEditMessage(selectadmin);
          setSelectuser("");
          getTodolistUserData();

          toast.success(myData?.message);
        } else {
          toast.error(myData?.message);
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // Get All asign Admin List Show
  const getAdmindata = async () => {
    await axiosInstanceAuth
      .get("/taskassignname")
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setShowAllUser(myData?.data);
        setFilteredData(myData?.data);
        console.log("Assign Admin List---->", myData);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  useEffect(() => {
    getAdmindata();
  }, []);

  // Delete API
  const DeleteApi = async () => {
    await axiosInstanceAuth
      .get(`delete_task/${getId}`)
      .then((res) => {
        const myDeleteData = decryptData(res?.data?.data);
        console.log("Delete Done --->", myDeleteData);
        if (myDeleteData.status) {
          getTodolistUserData();
          toast.success(myDeleteData?.message);
          emitEditMessage(myDeleteData?.data?.assignto);
          emitEdittodoMessage(myDeleteData?.data?.assignto);
        } else {
          toast.error(myDeleteData?.message);
        }
        setShowModal(false);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // Delete Modal Open
  const modelShows = (id) => {
    setShowModal(true);
    setId(id);
  };

  // Edit ID Wise Data Show API.
  const onChangeEdit = (e) => {
    const { name, value } = e.target;
    setEditData({
      ...editData,
      [name]: value,
    });
  };

  // console.log("🚀 ~ TodoListUser ~ myeditdata.selectadmin:", selectadmin);
  // console.log("🚀 🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀🚀", selectuserid);
  const myeditdata = {
    name: editData?.name,
    description: editData?.description,
    assignto: !selectadmin ? selectuserid : selectadmin,
    role: editData?.role,
    assigndate: editData?.assigndate,
    deadline: editData?.deadline,
  };

  // Get Data Particular ID Wise in Form
  const getEditData = async (id) => {
    await axiosInstanceAuth
      .get(`viewsingletask/${id}`)
      .then((res) => {
        setOpenEdit(true);
        setEditID(id);
        const myEditData = decryptData(res?.data?.data);
        console.log("🚀 ~ .then ~ myEditData:", myEditData);
        setEditData(myEditData?.data);
        setSelectuser(myEditData?.data?.assignto);
        setSelectuserid(myEditData?.data?.assigntoid);
        setSelectadmin(myEditData?.data?.assigntoid);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  // Updata Data Submit clcik
  const handleEditSubmit = async () => {
    await axiosInstanceAuth
      .post(`update_task/${getEditId}`, myeditdata)
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        console.log("=========myData", myData);
        console.log("=========logToken", myData?.data?.token);
        if (myData?.status) {
          getTodolistUserData();

          setSelectuser("");
          setSelectuserid("");
          toast.success(myData?.message);
          emitEditMessage(myData?.data?.assignto);
          emitEdittodoMessage(myData?.data?.assignto);
        } else {
          toast.error(myData?.message);
        }
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  const viewUserTodoList = (id) => {
    navigate(`/UserTodolistview/${id}`);
  };

  const handleOptionClick = (e, d) => {
    setSelectuser(e);
    setSelectadmin(d);
    setIsListVisible(!isListVisible);
  };

  const handleSearchChange = (e) => {
    const text = e.target.value;
    setSearchText(text);

    // Filter the user list based on the search text
    const filtered = showAllUser.filter((user) =>
      user.name.toLowerCase().includes(text)
    );
    setFilteredData(filtered);
  };
  useEffect(() => {
    const userId = selectadmin;
    const newSocket = io(BACKEND_BASE_URL, { query: { userId } });
    console.log("userid", userId);
    setSocket(newSocket);

    newSocket.on("todo_updated", (data) => {
      console.log("TODO updated:", data);
    });

    return () => {
      newSocket.disconnect();
    };
  }, []);
  return (
    <>
      <div className="container">
        <div className="flex justify-end">
          <button
            onClick={() => opencreatetask()}
            className="bg-[#22345C] gap-1  text-[#FFFFFF] font-sans text-lg font-bold py-3 px-4 rounded-[10px] inline-flex items-center"
          >
            <AiOutlinePlus size={25} className="text-[#FFFFFF]" />
            <span>Create New Task</span>
          </button>
        </div>

        {/* frist popup */}
        {createtask ? (
          <>
            <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center ">
              <div className="h-auto  filter-screen-model outline-none bg-white rounded-2xl shadow-2xl mx-5 ">
                <div>
                  <div>
                    <div className=" border-[1.5px] border-[#000000] m-10 rounded-[20px] p-">
                      <div className="flex justify-center items-center">
                        <div className="absolute">
                          <button className="bg-[#22345C] text-lg text-white font-sans underline font-bold py-2 px-4 rounded-[10px]">
                            Create New Task
                          </button>
                        </div>
                      </div>
                      <div className="p-5">
                        <div className="grid grid-cols-1 gap-6 mt-4 lg:grid-cols-">
                          <div>
                            <label
                              className="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Task Name <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              className="block w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                              name="name"
                              value={todoUserFields?.name}
                              onChange={onChangeInput}
                            />
                          </div>

                          <div>
                            <label
                              className="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Task Description{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              className="block w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                              name="description"
                              value={todoUserFields?.description}
                              onChange={onChangeInput}
                            />
                          </div>

                          <div className="relative">
                            <label
                              className="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Assigned To{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div
                              className="flex  items-center border border-black focus:outline-none  rounded-md bg-white py-2"
                              onClick={() => setIsListVisible(!isListVisible)}
                            >
                              <input
                                type="text"
                                className="block w-full px-2 text-[#000000]   rounded-md outline-none"
                                name="assignto"
                                value={selectuser}
                                onChange={onChangeInput}
                                placeholder="Select ---"
                              />
                              <MdOutlineKeyboardArrowDown
                                size={25}
                                className="right-8 flex justify-end"
                              />
                            </div>

                            {isListVisible && (
                              <div className=" absolute z-10 border-black border-[1px] px-2 py-2 mt-2 text-[#000000] font-sans  rounded-md bg-white  block w-full p-2.5 focus:outline-none">
                                <input
                                  type="text"
                                  value={searchText}
                                  onChange={handleSearchChange}
                                  placeholder="SearchAssign to"
                                  className="mb-2 h-[40px] w-full rounded-[6px] bg-[#F2F2F2] px-2 outline-none"
                                />
                                <div className="max-h-[200px] overflow-y-auto">
                                  {filtered?.length > 0 &&
                                    filtered.map((e, index) => (
                                      <div
                                        key={index}
                                        onClick={() =>
                                          handleOptionClick(e?.name, e?._id)
                                        }
                                        className="cursor-pointer px-2 py-1 hover:bg-gray-200"
                                      >
                                        {e?.name == "Assign to Me"
                                          ? ""
                                          : e?.name}
                                      </div>
                                    ))}
                                </div>
                              </div>
                            )}
                          </div>

                          <div>
                            <label
                              className="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Role <span className="text-red-500">*</span>
                            </label>
                            <select
                              class="border-black border-[1px] px-2 py-2 mt-2 text-[#000000] font-sans  rounded-md   block w-full p-2.5 focus:outline-none"
                              name="role"
                              value={todoUserFields?.role}
                              onChange={onChangeInput}
                            >
                              <option selected>Choose a any</option>
                              <option>User</option>
                            </select>
                          </div>

                          <div>
                            <label
                              class="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Assigned Date{" "}
                              <span className="text-red-500">*</span>
                            </label>

                            <div className="flex justify-between relative w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md ">
                              <DatePicker
                                className="outline-none w-[23rem]"
                                name="assigndate"
                                selected={todoUserFields?.assigndate}
                                placeholder="assignDate"
                                onChange={(date) =>
                                  setTodoUserFields({
                                    ...todoUserFields,
                                    assigndate: date,
                                  })
                                }
                              />
                              <FaCalendar className="right-2 absolute" />
                            </div>
                          </div>

                          <div>
                            <label
                              class="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Deadline <span className="text-red-500">*</span>
                            </label>

                            <div className="flex justify-between relative w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md ">
                              <DatePicker
                                className="outline-none w-[23rem]"
                                name="deadline"
                                selected={todoUserFields?.deadline}
                                placeholder="deadline"
                                onChange={(date) =>
                                  setTodoUserFields({
                                    ...todoUserFields,
                                    deadline: date,
                                  })
                                }
                              />
                              <FaCalendar className="right-2 absolute" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="flex justify-center mt-7 gap-4 mb-5">
                        <div className="">
                          <button
                            onClick={() => {
                              handleSubmit();
                              opencreatetask();
                            }}
                            class="bg-[#5DC90A]  px-6 py-2 leading-5  text-white font-bold  rounded-[6px]"
                          >
                            Submit
                          </button>
                        </div>
                        <div>
                          <button
                            onClick={() => opencreatetask()}
                            class="bg-[#FF270E] px-6 py-2 leading-5 text-white font-bold rounded-[6px]"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        {/* Edit User Popup  */}
        {openEdit ? (
          <>
            <div className="fixed top-0 left-[0%] z-[9999999999999] w-full h-full  backdrop-brightness-50 grid place-items-center place-content-center ">
              <div className="h-auto  filter-screen-model outline-none bg-white rounded-2xl shadow-2xl mx-5 ">
                <div>
                  <div>
                    <div className=" border-[1.5px] border-[#000000] m-10 rounded-[20px] p-">
                      <div className="flex justify-center items-center">
                        <div className="absolute">
                          <button class="bg-[#22345C] text-lg text-white font-sans underline font-bold py-2 px-4 rounded-[10px]">
                            Edit Task
                          </button>
                        </div>
                      </div>
                      <div className="p-5">
                        <div className="grid grid-cols-1 gap-6 mt-4 lg:grid-cols-">
                          <div>
                            <label
                              className="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Task Name
                            </label>
                            <input
                              type="text"
                              className="block w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                              name="name"
                              value={editData?.name}
                              onChange={onChangeEdit}
                            />
                          </div>

                          <div>
                            <label
                              className="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Task Description
                            </label>
                            <input
                              type="text"
                              className="block w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                              name="description"
                              value={editData?.description}
                              onChange={onChangeEdit}
                            />
                          </div>

                          <div className="relative">
                            <labels
                              className="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Assigned To
                            </labels>
                            <div
                              className="flex  items-center border border-black focus:outline-none  rounded-md bg-white py-2"
                              onClick={() => setIsListVisible(!isListVisible)}
                            >
                              <input
                                type="text"
                                className="block w-full px-2 text-[#000000]   rounded-md outline-none"
                                name="assignto"
                                value={selectuser}
                                onChange={onChangeEdit}
                                placeholder="Select ---"
                              />
                              <MdOutlineKeyboardArrowDown
                                size={25}
                                className="right-8 flex justify-end"
                              />
                            </div>

                            {isListVisible && (
                              <div className=" absolute z-10 border-black border-[1px] px-2 py-2 mt-2 text-[#000000] font-sans  rounded-md bg-white  block w-full p-2.5 focus:outline-none">
                                <input
                                  type="text"
                                  value={searchText}
                                  onChange={handleSearchChange}
                                  placeholder="SearchAssign to"
                                  className="mb-2 h-[40px] w-full rounded-[6px] bg-[#F2F2F2] px-2 outline-none"
                                />
                                <div className="max-h-[200px] overflow-y-auto">
                                  {filtered?.length > 0 &&
                                    filtered.map((e, index) => (
                                      <div
                                        key={index}
                                        onClick={() =>
                                          handleOptionClick(e?.name, e?._id)
                                        }
                                        className="cursor-pointer px-2 py-1 hover:bg-gray-200"
                                      >
                                        {e?.name}
                                      </div>
                                    ))}
                                </div>
                              </div>
                            )}
                          </div>

                          <div>
                            <label
                              className="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Role
                            </label>
                            <select
                              class="border-black border-[1px] px-2 py-2 mt-2 text-[#000000] font-sans  rounded-md   block w-full p-2.5 focus:outline-none"
                              name="role"
                              value={editData?.role}
                              onChange={onChangeEdit}
                            >
                              <option selected>Choose a any</option>
                              <option>User</option>
                            </select>
                          </div>

                          <div>
                            <label
                              class="text-[#22345C] underline font-sans font-bold text-lg"
                              for="username"
                            >
                              Deadline
                            </label>
                            <input
                              type="date"
                              class="block w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md outline-none"
                              name="deadline"
                              value={editData?.deadline?.slice(0, 10)}
                              onChange={onChangeEdit}
                            />
                          </div>

                          {/* <div className="flex justify-between relative w-96 px-2 py-2 mt-2 text-[#000000] bg-white border border-[#233966] rounded-md ">
                            <DatePicker
                              className="outline-none w-[23rem]"
                              name="deadline"
                              value={editData?.deadline?.slice(0, 10)}
                              placeholder="deadline"
                              onChange={(date) =>
                                setEditData({
                                  ...editData,
                                  deadline: date,
                                })
                              }
                            />
                            <FaCalendar className="right-2 absolute" />
                          </div> */}
                        </div>
                      </div>

                      <div class="flex justify-center mt-10 gap-4 mb-5">
                        <div>
                          <button
                            onClick={() => {
                              handleEditSubmit();
                              setOpenEdit(false);
                            }}
                            class="bg-[#5DC90A] px-6 py-2 leading-5  text-white font-bold  rounded-[10px]"
                          >
                            Submit
                          </button>
                        </div>
                        <div>
                          <button
                            onClick={() => setOpenEdit(false)}
                            class="bg-[#FF270E] px-6 py-2 leading-5 text-white font-bold rounded-[10px]"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        {/* Table show  */}
        <div>
          <div className="overflow-auto lg:overflow-visible mt-10">
            <table className="table w-full text-gray-400 border-separate space-y-6">
              <thead className="bg-[#22345C] text-white lg:text-xl">
                <tr>
                  <th className="p-3 text-left ">Task Title</th>
                  <th className="p-3 text-center ">Status</th>
                  <th className="p-3 text-center">Assigned To</th>
                  <th className="p-3 text-center ">Role</th>

                  <th className="p-3 text-center ">Assigned Date</th>

                  <th className="p-3 text-center ">Deadline</th>
                  <th className="p-3 text-center ">Action</th>
                </tr>
              </thead>
              <tbody>
                {sliceData?.length > 0 &&
                  sliceData?.map((d, index) => (
                    <tr
                      key={index}
                      className="bg-[#F5F7FD] lg:text-black font-bold font-sans text-lg"
                    >
                      <td className="p-3 space-y-">
                        <div>{d.name}</div>
                      </td>

                      <td className="p-3">
                        <div className="flex gap-1 items-center justify-center">
                          {d.status ? "Completed" : "Incompleted"}
                          <span>
                            {d.status ? (
                              <BiSolidCheckSquare
                                size={25}
                                className="text-[#5DC90A]"
                              />
                            ) : (
                              <BiSolidXSquare
                                size={25}
                                className="text-[#FF270E]"
                              />
                            )}
                          </span>
                        </div>
                      </td>

                      <td className="p-3 text-center">{d.assignto}</td>
                      <td className="p-3 text-center">{d.role}</td>
                      <td className="p-3 text-center">{d.assigndate}</td>
                      <td className="p-3 text-center">{d.deadline}</td>

                      <td className="p-3 ">
                        <div className="relative gap-2 flex items-center justify-center  ">
                          <button disabled={d?.status}>
                            <CiEdit
                              onClick={() => {
                                getEditData(d._id);
                              }}
                              size={25}
                              className="cursor-pointer  text-[#FFFFFF] bg-[#22345C] rounded-[3px] p-1"
                            />
                          </button>

                          <div>
                            <MdDelete
                              onClick={() => modelShows(d._id)}
                              size={25}
                              className="cursor-pointer text-[#FFFFFF]  bg-[#FF270E] rounded-[3px] p-1"
                            />

                            {showModal ? (
                              <>
                                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                                  <div className="relative w-auto my-6 mx-auto max-w-3xl">
                                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                      <div className="relative p-6 flex-auto">
                                        <span className="justify-center items-center flex">
                                          <AiFillDelete className="w-16 h-16 fill-red-500" />
                                        </span>
                                        <p className="my-4 text-center leading-relaxed text-2xl text-red-500">
                                          Are You Sure ?
                                        </p>
                                        <p className="my-4 text-slate-500 text-lg leading-relaxed">
                                          You want to Delete this User Task
                                        </p>
                                      </div>

                                      <div className="flex gap-2 items-center justify-end p-3 border-t border-solid border-slate-200 rounded-b">
                                        <button
                                          onClick={() => setShowModal(false)}
                                          class="text-red-500   font-bold py-2 px-6 rounded"
                                        >
                                          No
                                        </button>
                                        <button
                                          onClick={DeleteApi}
                                          class="bg-emerald-500 active:bg-emerald-600 px-6 py-2  text-white font-bold  rounded"
                                        >
                                          Yes
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                              </>
                            ) : null}
                          </div>

                          <div>
                            <HiOutlineEye
                              onClick={() => {
                                viewUserTodoList(d?._id);
                              }}
                              size={25}
                              className="cursor-pointer  text-[#FFFFFF] bg-[#22345C] rounded-[3px] p-1"
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* pagination Code  */}
        {allTodoUserData?.length > 1 ? (
          <div className="flex gap-2 pb-5 bottom-0">
            <button
              className="px-1 py-1 leading-tight  bg-[#FFFFFF] rounded-lg text-black text-xl"
              disabled={currentPage === 1}
              onClick={() => goToPage(currentPage - 1)}
            >
              <GrFormPrevious size={25} />
            </button>

            {numbers.map((item, index) => (
              <button
                disabled={item === "..."}
                className={`py-[3px] px-3  rounded-lg ${
                  currentPage === item &&
                  "bg-[#22345C] text-white font-bold font-sans"
                }`}
                onClick={() => goToPage(item)}
                key={index}
              >
                {item}
              </button>
            ))}

            <button
              className=" px-1 py-1  leading-tight  bg-[#FFFFFF] rounded-lg text-black text-xl"
              disabled={currentPage === totalPages}
              onClick={() => goToPage(currentPage + 1)}
            >
              <GrFormNext size={25} />
            </button>
          </div>
        ) : null}

        <div>
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n\n    .table {\n    border-spacing: 0 15px;\n  }\n\n  i {\n    font-size: 1rem !important;\n  }\n\n  .table tr {\n    border-radius: 20px;\n  }\n\n  tr td:nth-child(n + 7),\n  tr th:nth-child(n + 7) {\n    border-radius: 0 0.625rem 0.625rem 0;\n  }\n\n  tr td:nth-child(1),\n  tr th:nth-child(1) {\n    border-radius: 0.625rem 0 0 0.625rem;\n  }\n\n",
            }}
          />

          <link
            href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp"
            rel="stylesheet"
          />
        </div>
      </div>
    </>
  );
};

export default TodoListUser;
